import { render, staticRenderFns } from "./ChargesPage.vue?vue&type=template&id=60165fd6&"
import script from "./ChargesPage.vue?vue&type=script&lang=js&"
export * from "./ChargesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports